import { useEffect } from 'react';
import { PREPARATION_METHOD_LABELS } from '../utils/preparationCompatibility';
import './PreparationChangeConfirmModal.css';

function PreparationChangeConfirmModal({
  targetMethod,
  currentMethod,
  incompatibleNames,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  const targetLabel = PREPARATION_METHOD_LABELS[targetMethod] || targetMethod;
  const currentLabel = PREPARATION_METHOD_LABELS[currentMethod] || currentMethod;

  return (
    <div
      className="prep-change-overlay"
      onClick={onCancel}
      role="dialog"
      aria-modal="true"
      aria-labelledby="prep-change-title"
    >
      <div className="prep-change-modal" onClick={(e) => e.stopPropagation()}>
        <h2 id="prep-change-title" className="prep-change-modal__title">
          Switch to {targetLabel}?
        </h2>
        <p className="prep-change-modal__body">
          Your current selection includes ingredients that are not suited for{' '}
          {targetLabel.toLowerCase()} preparation. Switching from {currentLabel.toLowerCase()}{' '}
          will clear your blend so you can choose compatible ingredients.
        </p>
        {incompatibleNames.length > 0 && (
          <ul className="prep-change-modal__list">
            {incompatibleNames.map((name) => (
              <li key={name}>{name}</li>
            ))}
          </ul>
        )}
        <div className="prep-change-modal__actions">
          <button type="button" className="prep-change-modal__btn prep-change-modal__btn--secondary" onClick={onCancel}>
            Keep current method
          </button>
          <button type="button" className="prep-change-modal__btn prep-change-modal__btn--primary" onClick={onConfirm}>
            Yes, switch and start over
          </button>
        </div>
      </div>
    </div>
  );
}

export default PreparationChangeConfirmModal;
